import { Layout, Maybe } from "src/types.g";

export const sortLayoutsByZone = (
  layouts: Maybe<Layout>[]
): Maybe<Layout>[] => {
  return layouts.sort((a, b) => a!.zones - b!.zones);
};
